"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ToasterService = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INFO = 'INFO';
var SUCCESS = 'SUCCESS';
var ERROR = 'ERROR';
var WARNING = 'WARNING';
var ToasterService = exports.ToasterService = /*#__PURE__*/function () {
  function ToasterService() {
    (0, _classCallCheck2["default"])(this, ToasterService);
    (0, _defineProperty2["default"])(this, "toaster", null);
  }
  return (0, _createClass2["default"])(ToasterService, [{
    key: "register",
    value: function register(instance) {
      this.toaster = instance;
    }
  }, {
    key: "popToast",
    value: function popToast(newToast) {
      if (!this.toaster) {
        return;
      }
      this.toaster.popToast(_objectSpread({
        time: Date.now(),
        type: INFO,
        title: "Just so you're aware",
        message: 'This is the default toast text!'
      }, newToast));
    }
  }, {
    key: "info",
    value: function info(title, message) {
      this.popToast({
        type: INFO,
        title: title,
        message: message
      });
    }
  }, {
    key: "success",
    value: function success(title, message) {
      this.popToast({
        type: SUCCESS,
        title: title,
        message: message
      });
    }
  }, {
    key: "error",
    value: function error(title, message) {
      this.popToast({
        type: ERROR,
        title: title,
        message: message
      });
    }
  }, {
    key: "warning",
    value: function warning(title, message) {
      this.popToast({
        type: WARNING,
        title: title,
        message: message
      });
    }
  }]);
}();
var toaster = new ToasterService();
var _default = exports["default"] = toaster;